import Rx from 'rxjs/Rx';

export default class AccountInformationService {
    constructor($http, host, AuthService) {
        this.http = $http;
        this.host = host;
        this.authService = AuthService;
    }

    get timezone() {
        return this.authService.getProfile().account_timezone;
    }

    getUser() {
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: this.host + '/api/users'
        }).then(
            (resp) => resp.data,
            (resp) => { return {}; }
        ));
    }

    getAccountInfo() {
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: this.host + '/api/accounts'
        }).then(
            (resp) => resp.data,
            (resp) => resp
        ));
    }


    modifyPassword(password) {
        return Rx.Observable.fromPromise(this.http({
            method: 'PUT',
            url: this.host + '/api/users/password',
            data: { password: password }
        }));
    }

    saveInformation(data) {
        return Rx.Observable.fromPromise(this.http({
            method: 'PUT',
            url: this.host + '/api/accounts',
            data: data
        }));
    }

    createAccount(nameAccount) {
        return Rx.Observable.fromPromise(this.http({
            method: 'POST',
            url: this.host + '/api/accounts',
            data: { company: nameAccount }
        }));
    }

    isAccountAvailability(nameAccount) {
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: this.host + '/api/accounts/check-account',
            params: { company: nameAccount }
        }).then(
            (resp) => !resp.data.exists,
            (resp) => false
        ));
    }

    renameUser(firstName, lastName) {
        return Rx.Observable.fromPromise(this.http({
            method: 'PATCH',
            url: this.host + '/api/users',
            data: {first_name: firstName, last_name: lastName}
        }).then(
            (resp) => resp.data,
            (resp) => undefined
        ));
    }

    getAccountLogo(accountId, logoName) {
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: this.host + '/api/accounts/logo/' + accountId,
            params: {logo_name: logoName}
        }).then(
            (resp) => resp.data,
            (resp) => undefined
        ));
    }

    getTimezones(country){
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: this.host + '/api/timezones',
            params: {country: country}
        }).then(
            (resp) => resp.data.timezones,
            (resp) => undefined
        ));
    }

    chooseLanguage(language){
        return Rx.Observable.fromPromise(this.http({
            method: 'PATCH',
            url: this.host + '/api/users',
            data: {language: language}
        }).then(
            (resp) => resp.data,
            (resp) => undefined
        ));
    }

    getPaymentStatus(){
        return Rx.Observable.fromPromise(this.http({
            method: 'GET',
            url: `${this.host}/api/accounts/payments/status`
        }).then(
            resp => resp.data,
            resp => undefined
        ));
    }

}

AccountInformationService.$inject = ['$http', 'host', 'AuthService'];



// WEBPACK FOOTER //
// ./src/app/services/account-information.service.js